import React from 'react';
import styled from 'styled-components';
import Modal from '../../../../../../common/src/legacy/Modal';

interface Props {
  isOpen: boolean;
}

const DashedButtonModal: React.FC<React.PropsWithChildren<Props>> = ({
  isOpen,
  children,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      withGlobal={false}
      data-test-id="ProdFac_DashedButtonModal"
    >
      <FormWrapper>{children}</FormWrapper>
    </Modal>
  );
};

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  > div {
    max-width: 28rem;
  }
`;

export default DashedButtonModal;
